import { SUCCESS_STATUS } from "../const";

export const isSuccessResponse = (response) => {
  return response?.data?.status?.toUpperCase() === SUCCESS_STATUS;
};

export const isMaintenanceTime = (response) => {
  // {"code":503, "status":"MAINTENANCE","message":"Sorry for inconvenience, We are currently under a scheduled maintenance."}
  return response?.status === 503 && response.data?.code === 503;
};

export const isUnAuthOrSessionExpire = (response) => {
  return response && response.status === 401;
};

export const isHttpError = (response, error) => {
  return (
    !response ||
    error?.code === "ECONNABORTED" ||
    (response.status !== 200 && (response.data.error?.code || response.data.error?.message))
  );
};

export const isHttpErrorWithCustomError = (response) => {
  return !response || (response.status !== 200 && (response.data.code || response.data.message));
};

export function handleError(response) {
  if (!response) {
    return errorPayload("", "NO RESPONSE");
  }
  const errorMessage = response.data.message;
  const errorCode = response.data.code;
  const type = response.data.type;
  const title = response.data.title;
  if (!errorCode && !errorMessage) {
    return { isHttpError: true }; // show code: 1000 default error
  }
  return errorPayload(errorMessage, errorCode, type, title);
}

export function errorPayload(modalMessage, code, type, title) {
  return { modalMessage, code, type, title };
}

export function isAPIErrorWithoutInfo(response) {
  if (!response) return false;

  const data = response.data;
  return (
    response.status !== 200 &&
    data &&
    (data.hasOwnProperty("code") || data.hasOwnProperty("message")) &&
    !(data.code || data.message)
  );
}
